export default __webpack_public_path__ + "static/one-pa-homepage-logo-c0c052bf2fcc4698aae7f934cef44225.svg";